import script from "./order_view_btn.vue?vue&type=script&setup=true&lang=js"
export * from "./order_view_btn.vue?vue&type=script&setup=true&lang=js"

import "./order_view_btn.vue?vue&type=style&index=0&id=2282f523&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2282f523"]])

export default __exports__